export default __webpack_public_path__ + "static/media/alRight.f4caec20.mp3";